import React, { useState, useRef, useEffect, useCallback } from 'react'
import { PlusOutlined, CloseOutlined, FlagOutlined } from '@ant-design/icons'
import { Layout, Typography, Button, Modal, message, Divider, AutoComplete, Input, Avatar, Row, Col } from 'antd'
import { getClients } from '../../../../../../../Services/User/api'
import { getStores, getCities } from '@/domain/resource-management/resource-management.services'
import { firebaseSignOut } from '../../../../../../../../refactory/services/firebase/firebase'
import { useHookstate } from '@hookstate/core'
import { RolePermissionsSummaryModal } from '../../../../../../../../refactory/modules/access-control/infrastructure/roles-permissions/role-permissions-sumary-modal.component'
import { uploadFile, getFlagCategoriesByGroup } from '@domain/user-profile/user-profile.services.js'
import {
  UserProfileInfo,
  PersonalInfoModal,
  ChangeClientModal,
  GroupFlagsModal,
  GroupStoresModal
} from '@mercadoni/gungnir'
import './styles.less'
import { useTranslation } from 'react-i18next'
import { getUser } from '../../../../../../../../domain/user-management/user-management.services'
import { SubModulePerms, ModulePerms } from '../../../../../../../../refactory/modules/access-control/domain/module'
import { Can } from '../../../../../../../../refactory/modules/access-control/infrastructure/roles-permissions/access-control'
import { odinUserRepository } from '../../../../../../../../refactory/modules/access-control/infrastructure/odin-user.repository'
import { updateUserV3UseCase } from '../../../../../../../../refactory/modules/access-control/application/update-user-v3.use-case'
import { changeUserClientUseCase } from '../../../../../../../../refactory/modules/access-control/application/change-user-client.use-case'
import { useAuth } from '../../../../../../../../auth/Auth.hook'
import Session from '../../../../../../../Services/User/session'
import ChangePasswordModal from '../../../../../../../../refactory/modules/auth/infrastructure/change-password/ui/containers/ChangePasswordModal/ChangePasswordModal'

const PHONE_SALES_URL = process.env.REACT_APP_PHONE_SALES_URL
const { Header } = Layout
const { Text } = Typography

const IS_DEVELOPMENT = process.env.REACT_APP_ENV === 'development'

const HeaderScene = ({ history, title }) => {
  const PAGE_SIZE = 5
  const { userInfo, logout, getUserProfile, updateUserInfo } = useAuth()
  const [, setLoading] = useState(false)
  const { t } = useTranslation()
  const { info } = Modal
  const [statusTooggleIsLive, setStatusTooggleIsLive] = useState(userInfo.user.isLive)
  const [showModal, setShowModal] = useState(false)
  const [showClientModal, setShowClientModal] = useState(false)
  const [showPasswordModal, setShowPasswordModal] = useState(false)
  const [showUserProfile, setshowUserProfile] = useState(false)
  const [showGroupFlags, setShowGroupFlags] = useState(false)
  const [showGroupStores, setShowGroupStores] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [stores, setStores] = useState([])
  const [pagination, setPagination] = useState({ pageSize: PAGE_SIZE, showSizeChanger: false })
  const [filters, setFilters] = useState({
    limit: PAGE_SIZE,
    offset: 0
  })
  const [cities, setCities] = useState([])
  const [globalQuery, setGlobalQuery] = useState({})
  const showRolePermissionsSummaryModal = useHookstate(false)
  let storesAndCities = false
  let flagsQuery = false
  let clientsQuery = false

  useEffect(() => {
    if (userInfo && userInfo.user) {
      setStatusTooggleIsLive(userInfo.user.isLive)
    }
  }, [userInfo])

  const listCities = async () => {
    const filterOfCities = await getCities()
    filterOfCities &&
      setCities(
        filterOfCities.map((city) => {
          return { text: city, value: city }
        })
      )
  }

  const showGroupStoresModal = () => {
    storesAndCities = true
    setLoading(true)
    if (userInfo.user.groups.length && storesAndCities === true) {
      listCities()
      listStores(filters)
      setLoading(false)
    }
    setShowGroupStores(true)
    setshowUserProfile(false)
  }

  const groupStoresModalCancel = () => {
    setShowGroupStores(false)
  }

  const showGroupFlagsModal = () => {
    flagsQuery = true
    setLoading(true)
    if (userInfo.user.groups.length && flagsQuery === true) {
      listFlagsByGroup()
      setLoading(false)
    }
    setShowGroupFlags(true)
    setshowUserProfile(false)
  }

  const groupFlagsModalCancel = () => {
    setShowGroupFlags(false)
  }

  const showRoleInfoModal = () => {
    showRolePermissionsSummaryModal.set(true)
    setshowUserProfile(false)
  }

  const showPersonalInfoModal = () => {
    setShowModal(true)
    setshowUserProfile(false)
  }
  const handleCancel = (_e) => {
    setShowModal(false)
  }
  const showClientChangeModal = () => {
    clientsQuery = true
    setLoading(true)
    if (
      userInfo.user &&
      Can([SubModulePerms.USE_USER_GET_CLIENTS]) &&
      userInfo.user.email.endsWith(isInstaleap) &&
      clientsQuery === true
    ) {
      listClients()
      setLoading(false)
    }
    setShowClientModal(true)
    setshowUserProfile(false)
  }
  const handleClientCancel = (_e) => {
    setShowClientModal(false)
  }
  const showPasswordChangeModal = () => {
    if (!userInfo?.isSSO) {
      setShowPasswordModal(true)
    }
    setshowUserProfile(false)
  }
  const showPasswordChangeModal2 = () => {
    if (!userInfo?.isSSO) {
      setShowPasswordModal(true)
    }
    handleCancel(false)
  }
  const handlePasswordCancel = (_e) => {
    setShowPasswordModal(false)
  }
  const showUserProfileModal = () => {
    showUserProfile ? setshowUserProfile(false) : setshowUserProfile(true)
  }

  const callCenterIframe = useRef()
  const [clients, setClients] = useState([])
  const [htmlFlags, setHTMLFlags] = useState([])
  const [, setFlagsByGroup] = useState([])
  const isInstaleap = '@instaleap.io'

  const listFlagsByGroup = async () => {
    try {
      const flags = await getFlagCategoriesByGroup()
      let categories = {}
      Object.keys(flags).forEach((flag) => {
        if (flag.indexOf('TRANSFERRING') >= 0) {
          if (categories['transferAlerts']) {
            categories['transferAlerts'].push({ flags: flags[flag], categoryName: flag })
          } else {
            categories['transferAlerts'] = [{ flags: flags[flag], categoryName: flag }]
          }
        } else if (flag !== 'OTHERS') {
          if (categories['delayAlerts']) {
            categories['delayAlerts'].push({ flags: flags[flag], categoryName: flag })
          } else {
            categories['delayAlerts'] = [{ flags: flags[flag], categoryName: flag }]
          }
        } else {
          categories['otherAlerts'] = [{ flags: flags[flag], categoryName: flag }]
        }
      })
      const mappingFlags = (
        <div className='group-flags-modal-div'>
          <p>
            <div className='permit-flag'>
              <FlagOutlined />
            </div>
            {t('user-profile.enabled-alerts')}
          </p>
          <p>
            <div className='permit-disabled'>
              <FlagOutlined />
              {' ' + t('user-profile.disabled-alerts')}
            </div>
          </p>
          <p>
            <div className='permit-unassigned'>
              <CloseOutlined />
            </div>
            {t('user-profile.unassigned-alerts')}
          </p>
          {Object.keys(categories).map((category) => {
            const categoryName = `${t('user-profile.' + category)}`
            return (
              <div>
                <h3 className='category-title'>
                  <b>{categoryName}</b>
                  <Divider className='flag-category-divider' orientation='left' />
                </h3>
                <div className='subcategories'>
                  <Row>
                    {categories[category].map((subCategory) => {
                      if (t(subCategory.categoryName) !== 'OTHERS') {
                        return (
                          <Col span='6'>
                            <h4>{t(subCategory.categoryName) === 'OTHERS' ? null : t(subCategory.categoryName)}</h4>
                            {subCategory.flags.map((flag) =>
                              flag.isInGroup && userInfo.user.groups[0].flagCategories.includes(flag.id) ? (
                                <p>
                                  <div className='permit-flag'>
                                    <FlagOutlined />
                                  </div>
                                  {t('flags.' + flag.name)}
                                </p>
                              ) : flag.isInGroup && !userInfo.user.groups[0].flagCategories.includes(flag.id) ? (
                                <p>
                                  <div className='permit-disabled'>
                                    <FlagOutlined />
                                    {' ' + t('flags.' + flag.name)}
                                  </div>
                                </p>
                              ) : (
                                <p>
                                  <div className='permit-unassigned'>
                                    <CloseOutlined />
                                  </div>
                                  {t('flags.' + flag.name)}
                                </p>
                              )
                            )}
                          </Col>
                        )
                      } else {
                        return subCategory.flags.map((flag) =>
                          flag.isInGroup && userInfo.user.groups[0].flagCategories.includes(flag.id) ? (
                            <Col span='6'>
                              <div className='permit-flag'>
                                <FlagOutlined />
                              </div>
                              {t('flags.' + flag.name)}
                            </Col>
                          ) : flag.isInGroup && !userInfo.user.groups[0].flagCategories.includes(flag.id) ? (
                            <Col span='6'>
                              <div className='permit-disabled'>
                                <FlagOutlined />
                                {' ' + t('flags.' + flag.name)}
                              </div>
                            </Col>
                          ) : (
                            <Col span='6'>
                              <div className='permit-unassigned'>
                                <CloseOutlined />
                              </div>
                              {t('flags.' + flag.name)}
                            </Col>
                          )
                        )
                      }
                    })}
                  </Row>
                </div>
              </div>
            )
          })}
        </div>
      )
      setHTMLFlags(mappingFlags)

      setFlagsByGroup(await getFlagCategoriesByGroup())
    } catch (error) {
      console.warn('Error getting the flags by group', error)
    }
  }

  const gotFields = (user) => {
    return [
      {
        name: ['firstName'],
        value: user ? user.firstName : null
      },
      {
        name: ['lastName'],
        value: user ? user.lastName : null
      },
      {
        name: ['email'],
        value: user ? user.email : null
      }
    ]
  }

  const [, setFields] = useState(gotFields(userInfo))
  const [, setUploadBtn] = useState({
    value: null
  })

  const createAutoCompleteOptions = (_) => {
    return stores.map(({ location: { name } }) => {
      return { label: name, value: name }
    })
  }

  const listStores = async (query = {}) => {
    const { stores, numberOfPages } = await getStores(query)
    setStores(stores)
    let pag = { ...pagination }
    pag.total = PAGE_SIZE * numberOfPages
    setPagination(pag)
  }

  const searchStore = (name) => {
    const query = { ...filters, name, offset: 0 }
    setGlobalQuery(query)
    listStores(query)
    setSearchOpen(false)
  }

  const storesSearchbar = (
    <section className='new-store'>
      <AutoComplete
        onFocus={() => setSearchOpen(true)}
        onBlur={() => setSearchOpen(false)}
        onSearch={() => setSearchOpen(true)}
        open={searchOpen}
        defaultActiveFirstOption={false}
        backfill
        filterOption
        dropdownClassName='store-search-dropdown'
        options={createAutoCompleteOptions()}
        className='stores-search-autocomplete'
      >
        <Input.Search
          className='input-search-store'
          size='large'
          placeholder={t('resources.tab.STORES.searchStore')}
          onSearch={searchStore}
          allowClear={true}
        />
      </AutoComplete>
    </section>
  )

  const listClients = async () => {
    try {
      const clientsList = await getClients()
      clientsList.sort((a, b) => {
        return a.name.localeCompare(b.name)
      })
      setClients(clientsList)
    } catch (error) {
      console.warn('Error getting the clients', error)
    }
  }

  const handleStatusChange = useCallback(() => {
    const sessionUserInfo = Session.get('user_info')

    if (sessionUserInfo) {
      updateUserInfo(sessionUserInfo)
    } else if (userInfo) {
      updateUserInfo({ ...userInfo, user: { ...userInfo.user, isLive: false } })
    }
  }, [userInfo, updateUserInfo])

  React.useEffect(() => {
    const getShareStoreReference = async () => {
      let offset = 0
      let pageSize = 50
      const storesNebula = await getStoresRefence(pageSize, offset)
      let storeList = [...storesNebula.stores]

      if (storesNebula.numberOfPages > 1) {
        let index = 0
        while (index < storesNebula.numberOfPages) {
          offset += pageSize
          const { stores } = await getStoresRefence(pageSize, offset)
          storeList = [...storeList, ...stores]
          index++
        }
      }

      const iframe = document.getElementById('call-center-iframe')
      iframe.contentWindow.postMessage(
        {
          action: 'save',
          key: 'stores',
          value: storeList.map((store) => store.clientReference)
        },
        PHONE_SALES_URL
      )
    }
    window.addEventListener('storage', handleStatusChange)
    setFields(gotFields(userInfo))
    if (callCenterIframe.current) {
      callCenterIframe.current.onload = getShareStoreReference()
    }

    return () => {
      window.removeEventListener('storage', handleStatusChange)
    }
  }, [userInfo, handleStatusChange])

  const handleLogOut = async () => {
    const { id, isLive } = userInfo.user
    if (isLive) {
      await updateUserV3UseCase(odinUserRepository)(id, { isLive: false })
    }
    if (!IS_DEVELOPMENT) {
      logout({ federated: userInfo?.isSSO })
    } else {
      logout()
    }
    history.push(`/`)
    firebaseSignOut()
  }

  const changeStatus = async () => {
    setStatusTooggleIsLive(!statusTooggleIsLive)
    const { id, isLive } = userInfo.user

    if (!userInfo) {
      handleLogOut()
      return
    }
    setLoading(true)
    const userUpdated = await updateUserV3UseCase(odinUserRepository)(id, { isLive: !isLive })
    if (userUpdated) {
      getUserProfile()
      setLoading(false)
    }
  }

  const handleTableChange = (pagination, tableFilters) => {
    const { city } = tableFilters
    const { current } = pagination
    const offset = (current - 1) * filters.limit
    const query = {
      city: city && city.length > 0 ? city[0] : undefined,
      offset,
      name: globalQuery.name !== undefined && globalQuery.name !== '' ? globalQuery.name : undefined
    }
    setFilters({ ...filters, ...query })
    listStores({ ...filters, ...query })
  }

  const getStoresRefence = async (limit, offset) => {
    return await getStores({
      limit: limit,
      offset: offset,
      fields: ['clientReference']
    })
  }

  const openCallCenter = () => {
    PHONE_SALES_URL
      ? window.open(`${PHONE_SALES_URL}/?authToken=${window.localStorage.getItem('token')}`)
      : console.error('No Phone sales URL')
  }

  const updateUserProfile = async (userId, dataToUpdate) => {
    try {
      let response = null
      const userProfile = await getUser(userId)
      response = await updateUserV3UseCase(odinUserRepository)(userId, {
        firstName: dataToUpdate.firstName || userProfile.firstName,
        lastName: dataToUpdate.lastName || userProfile.lastName,
        email: userProfile.email,
        isLive: userProfile.isAvailable,
        roleId: userProfile.role.id || undefined,
        groupId: userProfile.group.id || undefined,
        isOkInAuth0: userProfile.isRegisteredInAuthenticationSystem,
        auth0Id: userProfile.authenticationId,
        avt_role_id: userProfile.avtRole?.id,
        photoUrl: userProfile.photoUrl || undefined
      })
      if (response) {
        info({
          title: t('user-profile.alert.updated'),
          content: t('user-profile.alert.updated-content'),
          onOk: () => {
            handleLogOut()
          }
        })
      }
    } catch (e) {
      console.error('Error updating user', e)
      message.error(t('user-profile.alert.error.update'))
    }
  }
  const changeUserClient = async (userId, clientData) => {
    const clientToChange = clients.find((client) => client.id === clientData.clientId)
    try {
      await changeUserClientUseCase(odinUserRepository)(userId, clientToChange)
      info({
        title: t('user-profile.alert.updated'),
        content: t('user-profile.alert.updated-content'),
        onOk: () => {
          handleLogOut()
        }
      })
    } catch (e) {
      message.error(t('user-profile.alert.error.update'))
    }
  }
  const uploadImage = (e, userId) => {
    const file = e.target.files[0]
    const formData = new FormData()
    formData.append('file', file)
    uploadFile(formData).then((result) => {
      setUploadBtn({
        value: result.location
      })
      updateUserProfile(userId, { photoUrl: result.location })
    })
  }

  const renderCallCenterButton = (_user) => {
    return (
      <>
        {Can([ModulePerms.CAL]) && (
          <Button style={{ marginRight: '1rem' }} type='primary' icon={<PlusOutlined />} onClick={openCallCenter}>
            {t('header.phone.sales')}
            <iframe
              ref={callCenterIframe}
              title='call-center'
              src={`${PHONE_SALES_URL}/storage.html`}
              id='call-center-iframe'
            ></iframe>
          </Button>
        )}
      </>
    )
  }

  const renderStoresModal = (groupsLength, user) => {
    if (groupsLength > 0) {
      return (
        <GroupStoresModal
          isVisible={showGroupStores}
          userGroup={user.groups[0].name}
          translate={t}
          toClose={groupStoresModalCancel}
          // eslint-disable-next-line array-callback-return
          storesData={stores.map((store) => {
            store.photoUrl = store.photoUrl.includes('https://instalp.co/6WuW')
              ? 'https://odin-images-and-files.s3.amazonaws.com/1624400600396_store.jpg'
              : store.photoUrl
            const {
              id,
              location: { name, city },
              fleetConfigurations
            } = store
            if (user.groups[0].stores && user.groups[0].stores.includes(store.id)) {
              return {
                key: id,
                photo: <Avatar size={60} src={store.photoUrl} />,
                name,
                city,
                fleets: fleetConfigurations.length
              }
            } else if (user.groups[0].allStores) {
              return {
                key: id,
                photo: <Avatar size={60} src={store.photoUrl} />,
                name,
                city,
                fleets: fleetConfigurations.length
              }
            }
          })}
          tableChange={handleTableChange}
          searchBar={storesSearchbar}
          cities={cities}
          pagination={pagination}
        />
      )
    }
  }

  const renderFlagsModal = (groupsLength, user) => {
    if (groupsLength > 0) {
      return (
        <GroupFlagsModal
          isVisible={showGroupFlags}
          userGroup={user.groups[0].name}
          translate={t}
          toClose={groupFlagsModalCancel}
          innerContent={htmlFlags}
        />
      )
    }
  }

  return (
    <Header className='header-menu'>
      <Text className='header-title' type='secondary'>
        {title}
      </Text>
      <div className='current-user'>
        {renderCallCenterButton(userInfo.user)}
        <UserProfileInfo
          isVisible={showUserProfile}
          onClick={showUserProfileModal}
          firstName={userInfo.user.firstName}
          lastName={userInfo.user.lastName}
          email={userInfo.user.email}
          client={userInfo.user.client.name}
          role={userInfo.user.avt_role?.name}
          userGroup={userInfo.user.groups.length ? userInfo.user.groups[0].name : null}
          isAvailable={statusTooggleIsLive}
          photoUrl={userInfo.user.photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
          isEnterprise={Can([SubModulePerms.USE_USER_CHANGE_CLIENT])}
          validActiveUser={userInfo.user && Can([SubModulePerms.FLA_GENERAL_AUTOMATIC_ASSIGN])}
          onRoleClick={showRoleInfoModal}
          translate={t}
          badgeColor={userInfo.user.isLive ? 'green' : 'red'}
          onAvailableSwitchChange={changeStatus}
          onLogOutClick={handleLogOut}
          onPersonalInfoClick={showPersonalInfoModal}
          onChangeClientClick={showClientChangeModal}
          onChangePasswordClick={showPasswordChangeModal}
          onGroupClick={showGroupFlagsModal}
          onGroupStoresClick={showGroupStoresModal}
        />
        {renderFlagsModal(userInfo.user.groups.length, userInfo.user)}
        {renderStoresModal(userInfo.user.groups.length, userInfo.user)}
        <PersonalInfoModal
          isVisible={showModal}
          userId={userInfo.user.id}
          toClose={handleCancel}
          firstName={userInfo.user.firstName}
          lastName={userInfo.user.lastName}
          email={userInfo.user.email}
          photoUrl={userInfo.user.photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
          client={userInfo.user.client.name}
          clientId={userInfo.user.client.id}
          onImageChange={uploadImage}
          gotFields={gotFields(userInfo.user)}
          updateUserFunction={updateUserProfile}
          changePasswordClick={showPasswordChangeModal2}
          translate={t}
        />
        <ChangeClientModal
          isVisible={showClientModal}
          userId={userInfo.user.id}
          toClose={handleClientCancel}
          firstName={userInfo.user.firstName}
          lastName={userInfo.user.lastName}
          email={userInfo.user.email}
          photoUrl={userInfo.user.photoUrl || 'https://instaleap.s3.amazonaws.com/user-placeholder.png'}
          client={userInfo.user.client.name}
          clientId={userInfo.user.client.id}
          clients={clients}
          gotFields={gotFields(userInfo.user)}
          updateUserFunction={changeUserClient}
          translate={t}
        />
        {showPasswordModal && <ChangePasswordModal open={showPasswordModal} handleCancel={handlePasswordCancel} />}
        {showRolePermissionsSummaryModal && (
          <RolePermissionsSummaryModal showModal={showRolePermissionsSummaryModal} user={userInfo.user} />
        )}
      </div>
    </Header>
  )
}

export default HeaderScene
